import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { Form, Progress, Row, Col, Container } from "reactstrap";
import { CSSTransition } from "react-transition-group";

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';

import logo from './img/group-8.svg';

const LoginForm = ({ api, location, TurnstileComponent, ...props }) => {
  const nodeRef = useRef(null);
  const { translate, changeDefaultLocale } = useLocalization();
  changeDefaultLocale('es');
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);
  parameters.idp = 'cplus';

  useEffect(() => {
    setShowForm(true)
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    api.userPassLogin(
      {
        username,
        password,
      },
      parameters
    )
      .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);

        let message = "Hubo un error: " + error.message;

        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message: message })
      });
  }

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <div className="cplus-form-container" ref={nodeRef}>
        <div className="rectangle-2"></div>
        <Form onSubmit={(event) => onSubmit(event)}>
          <Container fluid={true} className="cplus-form-middle-container">
            <Row style={{ marginBottom: 25 }}>
              <Col>
                <img src={logo} alt="logo" className="logo-cplus rounded mx-auto d-block" />
                <div className="form-title">Iniciar Sesión</div>
              </Col>
            </Row>
            <Row className="cplus-form-body">
              <Col sm="12" xs="12" md="12">
                <input
                  style={{ width: '100%', }}
                  className=" input-cplus"
                  disabled={onLogin}
                  required={true}
                  tabIndex={1}
                  type="text"
                  autoCorrect="off"
                  autoCapitalize="none"
                  id="username"
                  placeHolder="Usuario"
                  onChange={e => setUsername(e.target.value)}
                />
              </Col>
            </Row>
            <Row className="cplus-form-body ">
              <Col sm="12" xs="12" md="12">
                <input
                  className=" input-cplus"
                  required={true}
                  disabled={onLogin}
                  tabIndex={1}
                  type="password"
                  autoCorrect="off"
                  autoCapitalize="none"
                  id="password"
                  placeholder="Contraseña"
                  onChange={e => setPassword(e.target.value)}
                />
              </Col>
            </Row>
            <Row className="cplus-form-footer">
              <Col sm="12" xs="12" md="12" style={{ textAlign: 'center', padding: '0' }}>

                <div className="messages-container cplus-error">
                  {error.message}
                </div>
                {!onLogin ? (
                  <div>
                    <button
                      tabIndex={1}
                      type="submit"
                      id="submmit"
                      className="enter-cplus"
                      disabled={!props.turnstileSuccess}
                    >
                      {translate("ButtonEnter")}
                    </button>
                  </div>
                ) : (
                  <Progress animated color="danger" value={100} />
                )}
                <TurnstileComponent setTurnstileSuccess={props.setTurnstileSuccess} />
              </Col>
            </Row>
          </Container>
        </Form>
      </div>
    </CSSTransition>
  );
}

export default WithCaptcha(LoginForm, { useInsideForm: true, style: { marginTop: '2rem' } });
